import Vue from 'vue'
import Router from 'vue-router'
import HomePage from 'views/HomePage.vue'
import LoginPage from 'views/LoginPage.vue'
// import SignUpPage from 'views/SignUpPage.vue'
import OrderPage from 'views/OrderPage.vue'
import CheckoutPage from 'views/CheckoutPage.vue'
import PostPurchasePage from 'views/PostPurchasePage.vue'

import AdminPage from './views/AdminPage.vue'
import LegalPage from './views/LegalPage.vue'
import StoriesPage from './views/StoriesPage.vue'
import InfoPage from './views/infoPage/InfoPage.vue'

import authentication from 'services/authentication.js'
import analytics from 'services/analytics.js'
import logScope from 'log-scope'
import funnel from 'script/funnel.js'

const log = logScope('router')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage,
      props: (route) => route.query
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage
    }, /*
    {
      path: '/signup',
      name: 'SignUpPage',
      component: SignUpPage
    }, */
    {
      path: '/legal',
      name: 'LegalPage',
      component: LegalPage
    },
    {
      path: '/admin',
      name: 'AdminPage',
      meta: {
        requiresAuth: true
      },
      component: AdminPage
    },
    {
      path: '/order/:code?',
      name: 'OrderPage',
      component: OrderPage
    },
    {
      path: '/checkout',
      name: 'CheckoutPage',
      component: CheckoutPage
    },
    {
      path: '/thanks',
      name: 'PostPurchasePage',
      component: PostPurchasePage
    },
    {
      path: '/stories',
      name: 'StoriesPage',
      component: StoriesPage
    },
    {
      path: '/info/:lang/:product',
      name: 'InfoPage',
      component: InfoPage
    },
    {
      path: '/:partner?',
      name: 'PartnerPage',
      component: OrderPage
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

window.goToAdmin = () => {
  router.push({ name: 'AdminPage' })
}

router.beforeEach((to, from, next) => {
  const currentUser = authentication.getUser()
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  log.debug('Routing', to.name)

  // Track "pages"
  if (typeof from.name === 'string' && from.name.length > 0) {
    log.success('Logging to GA, path: ' + to.path)
    analytics.pageView(to.path)
    funnel.addStep(to.name)
  }

  if (requiresAuth && !currentUser) {
    log.danger('Redirecting not logged in user to Login')
    next('login')
  } else {
    next()
  }
})

export default router
